import MuiLoadingButton, {
  // eslint-disable-next-line import/named
  LoadingButtonProps as MuiLoadingButtonProps,
} from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";

interface LoadingButtonProps extends MuiLoadingButtonProps {
  componentName: string;
  helperText?: string;
}

export const Button = ({
  componentName,
  variant = "contained",
  helperText,
  ...props
}: LoadingButtonProps) => {
  return (
    <>
      <MuiLoadingButton
        {...props}
        data-testid={`${componentName}-loading-button`}
        variant={variant}
        sx={{
          border: "2px solid #000000",
          boxShadow: "3px 3px 0px 0px #000000",
          ...props.sx,
        }}
      />
      {helperText && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: "block",
            marginTop: 1,
            textAlign: "center",
          }}
        >
          {helperText}
        </Typography>
      )}
    </>
  );
};
